import { useState } from 'react'
import RuleBuilder from './RuleBuilder.jsx'

// Une action, réglée sans jamais montrer son type technique. Chaque cas
// n'affiche que les deux ou trois champs qui le concernent.
export default function ActionForm({ action, etapes, catalogue, vocabulaire,
                                     onEnregistrer, onSupprimer, onDupliquer, onAnnuler }) {
  const [a, setA] = useState({ ...action })
  const maj = (champs) => setA({ ...a, ...champs })

  const titres = {
    jump: a.kind === 'agent' ? "Bouton pour l'agent" : 'Aiguillage automatique',
    delay: 'Passage après un délai',
    ask_user: "Demander un complément à l'habitant",
    email: 'Envoi de courriel',
    sms: 'Envoi de SMS',
    notify: "Message affiché à l'habitant",
    alert: 'Alerte pour les agents',
    document: 'Génération de document',
    criticity: 'Niveau de priorité',
    history: 'Écriture au registre',
    webservice: "Appel d'un logiciel externe",
  }

  const ChoixEtape = ({ id, label, aide }) => (
    <div className="champ">
      <label htmlFor={id}>{label}</label>
      <select id={id} value={a.target || ''} onChange={(e) => maj({ target: e.target.value })}>
        <option value="">Choisir une étape…</option>
        {etapes.map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
      </select>
      {aide && <p className="aide">{aide}</p>}
    </div>
  )

  return (
    <div className="fenetre" role="dialog" aria-label="Réglages de l'action">
      <div className="fenetre-corps large">
        <h2>{titres[a.type] || 'Action'}</h2>

        {a.type === 'jump' && a.kind === 'agent' && (
          <>
            <div className="champ">
              <label htmlFor="ac-label">Texte du bouton</label>
              <input id="ac-label" value={a.label || ''} autoFocus
                     onChange={(e) => maj({ label: e.target.value })} />
              <p className="aide">Commencez par un verbe : « Accepter la demande »,
                « Transmettre au service ».</p>
            </div>
            <ChoixEtape id="ac-target" label="Le dossier part vers" />
            <div className="ligne-champs">
              <div className="champ">
                <label htmlFor="ac-tone">Apparence</label>
                <select id="ac-tone" value={a.tone || ''} onChange={(e) => maj({ tone: e.target.value })}>
                  <option value="pri">Bouton principal</option>
                  <option value="">Bouton normal</option>
                  <option value="dgr">Refus, action négative</option>
                </select>
              </div>
              <div className="champ">
                <label htmlFor="ac-req">Faut-il un motif écrit ?</label>
                <select id="ac-req" value={a.require_comment ? '1' : '0'}
                        onChange={(e) => maj({ require_comment: e.target.value === '1' })}>
                  <option value="0">Non, un clic suffit</option>
                  <option value="1">Oui, l'agent doit expliquer</option>
                </select>
              </div>
            </div>
            <div className="champ">
              <label htmlFor="ac-mail">Courriel envoyé au clic</label>
              <select id="ac-mail" value={a.mail_id || ''}
                      onChange={(e) => maj({ mail_id: e.target.value || null })}>
                <option value="">Aucun</option>
                {catalogue.mails.map((m) => <option key={m.key} value={m.key}>{m.name}</option>)}
              </select>
            </div>
          </>
        )}

        {a.type === 'jump' && a.kind === 'auto' && (
          <>
            <ChoixEtape id="ac-target" label="Le dossier part vers" />
            <div className="champ">
              <label htmlFor="ac-label">Nom de l'aiguillage</label>
              <input id="ac-label" value={a.label || ''}
                     onChange={(e) => maj({ label: e.target.value })} />
              <p className="aide">Apparaît au registre du dossier quand l'aiguillage joue.</p>
            </div>
          </>
        )}

        {a.type === 'delay' && (
          <>
            <div className="ligne-champs">
              <div className="champ">
                <label htmlFor="ac-n">Au bout de</label>
                <input id="ac-n" type="number" min="1" value={a.delay?.n || 15}
                       onChange={(e) => maj({ delay: { ...a.delay, n: Number(e.target.value) } })} />
              </div>
              <div className="champ">
                <label htmlFor="ac-u">Unité</label>
                <select id="ac-u" value={a.delay?.unit || 'jour'}
                        onChange={(e) => maj({ delay: { ...a.delay, unit: e.target.value } })}>
                  {catalogue.delay_units.map((u) => <option key={u} value={u}>{u}(s)</option>)}
                </select>
              </div>
            </div>
            <ChoixEtape id="ac-target" label="Le dossier passe à"
                        aide="Le compteur repart de zéro à chaque changement d'étape." />
            <div className="champ">
              <label htmlFor="ac-label">Nom affiché au registre</label>
              <input id="ac-label" value={a.label || ''}
                     onChange={(e) => maj({ label: e.target.value })} />
            </div>
          </>
        )}

        {a.type === 'ask_user' && (
          <>
            <div className="champ">
              <label htmlFor="ac-label">Texte du bouton</label>
              <input id="ac-label" value={a.label || ''} autoFocus
                     onChange={(e) => maj({ label: e.target.value })} />
            </div>
            <ChoixEtape id="ac-target" label="Étape d'attente"
                        aide="Le dossier y patiente. Dès que l'habitant répond, il revient tout seul à l'étape d'où le bouton a été cliqué." />
            <div className="champ">
              <label htmlFor="ac-ask">Question proposée par défaut</label>
              <input id="ac-ask" value={a.ask || ''}
                     placeholder="L'agent peut la reformuler au moment du clic"
                     onChange={(e) => maj({ ask: e.target.value })} />
            </div>
          </>
        )}

        {a.type === 'email' && (
          <>
            <div className="champ">
              <label htmlFor="ac-mail">Courriel type</label>
              <select id="ac-mail" value={a.mail_id || ''}
                      onChange={(e) => maj({ mail_id: e.target.value })}>
                <option value="">Choisir…</option>
                {catalogue.mails.map((m) => <option key={m.key} value={m.key}>{m.name}</option>)}
              </select>
            </div>
            <div className="champ">
              <label htmlFor="ac-to">Destinataire</label>
              <input id="ac-to" value={a.to || 'demandeur'}
                     onChange={(e) => maj({ to: e.target.value })} />
              <p className="aide">Laissez « demandeur » pour écrire à l'habitant, ou saisissez
                l'adresse d'un service.</p>
            </div>
          </>
        )}

        {['sms', 'notify', 'alert'].includes(a.type) && (
          <div className="champ">
            <label htmlFor="ac-text">Texte</label>
            <textarea id="ac-text" rows={3} value={a.text || ''} autoFocus
                      onChange={(e) => maj({ text: e.target.value })} />
            <p className="aide">Vous pouvez insérer des informations du dossier, par exemple
              le numéro, avec les doubles accolades.</p>
          </div>
        )}

        {a.type === 'history' && (
          <>
            <div className="champ">
              <label htmlFor="ac-text">Texte inscrit au registre</label>
              <textarea id="ac-text" rows={3} value={a.text || ''} autoFocus
                        onChange={(e) => maj({ text: e.target.value })} />
            </div>
            <div className="champ">
              <label htmlFor="ac-vis">Qui le voit</label>
              <select id="ac-vis" value={a.visible ? '1' : '0'}
                      onChange={(e) => maj({ visible: e.target.value === '1' })}>
                <option value="0">Les agents seulement</option>
                <option value="1">Aussi l'habitant, sur son suivi</option>
              </select>
            </div>
          </>
        )}

        {a.type === 'document' && (
          <div className="champ">
            <label htmlFor="ac-name">Nom du document produit</label>
            <input id="ac-name" value={a.name || ''} autoFocus
                   onChange={(e) => maj({ name: e.target.value })} />
            <p className="aide">La pièce s'ajoute au dossier et devient visible de l'habitant.</p>
          </div>
        )}

        {a.type === 'criticity' && (
          <div className="champ">
            <label htmlFor="ac-level">Niveau appliqué</label>
            <select id="ac-level" value={a.level || 'high'}
                    onChange={(e) => maj({ level: e.target.value })}>
              {catalogue.criticities.map((c) => <option key={c.key} value={c.key}>{c.label}</option>)}
            </select>
            <p className="aide">Les dossiers prioritaires portent une pastille et se filtrent
              dans la liste.</p>
          </div>
        )}

        {a.type === 'webservice' && (
          <>
            <div className="champ">
              <label htmlFor="ac-label">Intitulé</label>
              <input id="ac-label" value={a.label || ''}
                     onChange={(e) => maj({ label: e.target.value })} />
            </div>
            <div className="ligne-champs">
              <div className="champ">
                <label htmlFor="ac-method">Méthode</label>
                <select id="ac-method" value={a.method || 'POST'}
                        onChange={(e) => maj({ method: e.target.value })}>
                  {['POST', 'GET', 'PUT'].map((m) => <option key={m}>{m}</option>)}
                </select>
              </div>
              <div className="champ">
                <label htmlFor="ac-url">Adresse appelée</label>
                <input id="ac-url" className="mono" value={a.url || ''}
                       onChange={(e) => maj({ url: e.target.value })} />
              </div>
            </div>
          </>
        )}

        <hr />
        <RuleBuilder vocabulaire={vocabulaire} valeur={a.condition}
                     onChange={(condition) => maj({ condition })} />

        <div className="ligne separee">
          {onSupprimer && <button className="btn dgr" onClick={() => onSupprimer(a)}>Supprimer</button>}
          {onDupliquer && <button className="btn" onClick={() => onDupliquer(a)}>Dupliquer</button>}
          <div className="pousse" />
          <button className="btn" onClick={onAnnuler}>Annuler</button>
          <button className="btn pri" onClick={() => onEnregistrer(a)}>Enregistrer</button>
        </div>
      </div>
    </div>
  )
}
